<!-- Report Header -->
<div class="report-header bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900
            backdrop-blur-sm border-b border-gray-200 dark:border-gray-700 px-6 py-4 rounded-t-lg shadow-sm">
    <div class="flex items-center justify-between">
        <!-- Left -->
        <div class="flex items-center space-x-4">
            <a [routerLink]="['/main/reports']"
                class="group flex items-center justify-center w-10 h-10 rounded-full bg-white dark:bg-gray-700 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 border border-gray-200 dark:border-gray-600">
                <i class="pi pi-arrow-left text-gray-600 dark:text-gray-300 group-hover:text-blue-600 
                         dark:group-hover:text-blue-400 transition-colors duration-200"></i>
            </a>
            <div class="flex flex-col">
                <h1 class="font-bold text-xl text-gray-900 dark:text-white mb-0">{{ title }}</h1>
                <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Ticket Management Overview</p>
            </div>
        </div>

        <!-- Right -->
        <div *ngIf="slug != 'converted-leads'" class="flex space-x-3">
            <button pButton label="Filter" icon="pi pi-filter" (click)="openBulkFilter()"
                class="p-button-outlined p-button-sm bg-white dark:bg-gray-700 border-gray-300 
                       dark:border-gray-600 hover:bg-blue-50 dark:hover:bg-gray-600 transition-all duration-200 shadow-sm hover:shadow-md">
            </button>
            <button pButton icon="pi pi-download"
                class="p-button-outlined p-button-sm bg-white dark:bg-gray-700 border-gray-300 
                       dark:border-gray-600 hover:bg-green-50 dark:hover:bg-gray-600 transition-all duration-200 shadow-sm hover:shadow-md"
                pTooltip="Export Data" tooltipPosition="bottom">
            </button>
        </div>
    </div>
</div>

<!-- Ticket Table -->
<div
    class="table-container rounded-[20px] mx-6 mt-4 bg-white dark:bg-gray-800 shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRows" [lazy]="true"
        (onLazyLoad)="loadData($event)" [loading]="isDataLoading" styleClass="beautiful-table" [scrollable]="true"
        scrollHeight="calc(92vh - 150px)" [resizableColumns]="true"
        [rowsPerPageOptions]="totalRows > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <!-- Table Header -->
        <ng-template pTemplate="header">
            <tr class="bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800">
                <th class="table-header">
                    <i class="pi pi-ticket mr-2 text-blue-600"></i>
                    Ticket ID
                </th>
                <th class="table-header">
                    <i class="pi pi-file mr-2 text-green-600"></i>
                    Title
                </th>
                <th class="table-header">
                    <i class="pi pi-tag mr-2 text-purple-600"></i>
                    Source
                </th>
                <th class="table-header">
                    <i class="pi pi-user mr-2 text-orange-600"></i>
                    Created By
                </th>
                <th class="table-header">
                    <i class="pi pi-info-circle mr-2 text-blue-500"></i>
                    Description</th>
                <th class="table-header">
                    <i class="pi pi-check-circle mr-2 text-gray-400"></i>
                    Status
                </th>
                <th class="table-header">
                    <i class="pi pi-calendar mr-2 text-red-500"></i>
                    Requested On
                </th>
                <th class="table-header">
                    <i class="pi pi-calendar mr-2 text-blue-500"></i>
                    Updated On
                </th>
                <th class="table-header">
                    <i class="pi pi-user mr-2 text-indigo-600"></i>
                    Assigned To
                </th>
                <th class="table-header">
                    <i class="pi pi-flag mr-2 text-pink-600"></i>
                    Priority
                </th>
            </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-element let-rowIndex="rowIndex">
            <tr class="table-row hover:bg-blue-50 dark:hover:bg-gray-700 transition-all duration-200"
                [class.even-row]="rowIndex % 2 === 0">

                <td class="table-cell">{{ element.ticket_id }}</td>

                <td class="table-cell">{{ element.title || 'N/A' }}</td>

                <!-- Source -->
                <td class="table-cell">
                    <img [src]="getLeadSourceImg(element['source'])" class="h-[33px] w-[30px] object-contain ml-4" />
                </td>

                <td class="table-cell">
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium 
                                 bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100">
                        {{ element.created_by?.name || 'N/A' }}</span>
                </td>

                <!-- Description -->
                <td class="table-cell text-center">
                    <div class="text-center">
                        <i class="pi pi-info-circle  cursor-pointer info-circle-icon"
                            pTooltip="{{ element.ticket_desc }}" tooltipPosition="top"
                            tooltipStyleClass="tooltip-style"></i>
                    </div>
                </td>

                <!-- Status -->
                <td class="table-cell">
                    <div class="flex items-center gap-1 rounded-full px-5 py-[1px] w-fit min-w-[120px] font-medium h-[28px]"
                        [style.borderWidth]="'2px'" [style.borderStyle]="'solid'"
                        [style.borderColor]="getStatusColor(element.ticket_status)"
                        [style.color]="getStatusColor(element.ticket_status)" style="font-weight: 500;">
                        <div style="margin-top: 2px;">
                            <svg width="25px" height="25px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <g [attr.stroke]="getStatusColor(element.ticket_status)" stroke-width="3" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path
                                        d="M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z M11.0150512,21 C9.04777237,21 6.37608863,21 3,21 C3.79921286,17.89195 6.4614209,16.2328962 10.9866241,16.0228387">
                                    </path>
                                    <polyline points="21.0037832 16.5969533 17 21 14.4906972 18.5114193">
                                    </polyline>
                                </g>
                            </svg>
                        </div>
                        {{
                        element.ticket_status || 'N/A'
                        }}
                    </div>
                </td>

                <!-- Dates -->
                <td class="table-cell">{{ element.createdAt | date : 'dd-MM-yyyy' }}</td>
                <td class="table-cell">{{ element.updatedAt | date : 'dd-MM-yyyy' }}</td>

                <!-- Assigned To -->
                <td class="table-cell">
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium 
                                 bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100">
                        {{ element?.assignedUser?.fname ? element.assignedUser.fname + ' ' + element.assignedUser.lname
                        : 'Unassigned' }}
                    </span>
                </td>

                <!-- Priority -->
                <td class="table-cell">
                    <span *ngIf="element.priority" class="px-3 py-1 rounded-full text-xs font-medium border" [ngClass]="{
                            'bg-red-100 text-red-800 border-red-300': element.priority.toLowerCase() === 'urgent',
                            'bg-orange-100 text-orange-800 border-orange-300': element.priority.toLowerCase() === 'high',
                            'bg-yellow-100 text-yellow-800 border-yellow-300': element.priority.toLowerCase() === 'normal',
                            'bg-gray-100 text-gray-800 border-gray-300': element.priority.toLowerCase() === 'low'
                        }">
                        {{ element.priority }}
                    </span>
                    <span *ngIf="!element.priority" class="text-gray-400 italic">N/A</span>
                </td>
            </tr>
        </ng-template>

        <!-- Empty State -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="10" class="text-center py-16">
                    <div class="flex flex-col items-center space-y-4">
                        <i class="pi pi-inbox text-6xl text-gray-300 dark:text-gray-600"></i>
                        <h3 class="text-lg font-medium text-gray-900 dark:text-white">No tickets found</h3>
                        <p class="text-gray-500 dark:text-gray-400">Try adjusting your filters or check back later.</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Filter Sidebar -->
<p-drawer [(visible)]="isOpen" position="right" [baseZIndex]="10000" styleClass="modern-drawer">
    <ng-template pTemplate="header">
        <div class="flex items-center space-x-3">
            <div
                class="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                <i class="pi pi-filter text-blue-600 dark:text-blue-400"></i>
            </div>
            <div>
                <h3 class="text-lg font-semibold text-white mb-0">Advanced Filters</h3>
                <p class="text-sm text-white">Refine your ticket view</p>
            </div>
        </div>
    </ng-template>

    <div class="space-y-6 mt-6">
        <!-- Ticket Status -->
        <div *ngIf="slug == 'tickets-by-status'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Status</label>
            <p-multiselect [options]="ticketStatusList" [(ngModel)]="selectedTicketStatusFilter"
                placeholder="Select Status" optionLabel="label" display="chip" class="w-full" />
        </div>

        <!-- Priority -->
        <div *ngIf="slug == 'tickets-by-priority'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Priority</label>
            <p-multiselect [options]="priorityList" [(ngModel)]="selectedTicketPriorityFilter"
                placeholder="Select Priority" optionLabel="label" display="chip" class="w-full" />
        </div>

        <!-- Source -->
        <div *ngIf="slug == 'tickets-by-source'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Source</label>
            <p-multiselect [options]="leadSourceList" [(ngModel)]="selectedTicketSourceFilter"
                placeholder="Select Source" optionLabel="label" display="chip" class="w-full" />
        </div>

        <!-- Owner -->
        <div *ngIf="slug == 'tickets-assigned-to'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Owner</label>
            <p-multiselect [options]="leadOwnerList" [(ngModel)]="selectedLeadOwnerFilter"
                placeholder="Select Owner" optionLabel="name" display="chip" class="w-full" />
        </div>

        <!-- Actions -->
        <div class="flex flex-col space-y-3 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p-button label="Apply Filters" icon="pi pi-check" (click)="applyBulkFilter()" [loading]="filterLoading"
                styleClass="p-button-primary w-full modern-button">
            </p-button>
        </div>
    </div>
</p-drawer>